module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selection-container"
  }, [_c('div', {
    staticClass: "pl-subheading"
  }, [_vm._v("\n    Will your students be anonymous to each other?\n    "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.anonymity_description),
      expression: "anonymity_description"
    }],
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "radio-button-container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "10px 10px 10px 0px"
    }
  }, [_c('pl-radio', {
    attrs: {
      "value": false
    },
    model: {
      value: (_vm.anonymity_status),
      callback: function($$v) {
        _vm.anonymity_status = $$v
      },
      expression: "anonymity_status"
    }
  }), _vm._v(" "), _c('span', [_vm._v("No, student names are revealed.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "10px 10px 10px 0px"
    }
  }, [_c('pl-radio', {
    attrs: {
      "value": true
    },
    model: {
      value: (_vm.anonymity_status),
      callback: function($$v) {
        _vm.anonymity_status = $$v
      },
      expression: "anonymity_status"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Yes, students are anonymous.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "close-button end-xs"
  }, [(_vm.user_has_changed_status) ? _c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": !_vm.user_has_changed_status
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateAnonymityStatus.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Save Changes\n    ")]) : _c('pl-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('closeTab')
      }
    }
  }, [_vm._v(" Close ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-487e02c1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/pages/feed/roundtableSettingsTabs/anonymitySettingsTab.vue
// module id = 1306
// module chunks = 61